import { connect } from 'react-redux';
import View from './AdviserSettingsView';
import {
  showAssetClassMappingSelector,
  firmSettingsAccessSelector,
  showFinancialPlanningSelector,
  selectHasAssetBucketingFirm,
  dataFeedsUrlSelector,
} from '../AdviserArea/AdviserAreaSelector';
import { currentRouteSelector } from '../CommonComponents/Router/Selector';

const mapStateToProps = state => ({
  showAssetClassMapping: showAssetClassMappingSelector(state),
  currentRoute: currentRouteSelector(state),
  firmSettingsAccess: firmSettingsAccessSelector(state),
  showFinancialPlanning: showFinancialPlanningSelector(state),
  hasAssetBucketingFirm: selectHasAssetBucketingFirm(state),
  dataFeedsUrl: dataFeedsUrlSelector(state),
});

export default connect(mapStateToProps)(View);
